/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { LinkButton, Text } from '@blend/enterprise-components';

import { respondToAuthChallenge } from 'id-api/auth';
import { FormCard } from 'id-components/FormCard';
import { useChallengeCookie, useLoginFlowSubmit } from 'id-utils/login';

// used by calipers
const ID_SETUP_MFA_EMAIL = 'it-SetupMFA-Email';

export namespace EmailMFAForm {
  export interface Props {
    setUseEmailMFA: (bool: boolean) => void;
  }
}

export const EmailMFAForm: React.FC<EmailMFAForm.Props> = ({ setUseEmailMFA }) => {
  const challengeCookieResult = useChallengeCookie();
  const username = challengeCookieResult.cookie?.username;

  const getEmailMFAFormValues = () => ({ mfaType: 'EMAIL' });
  const onEmailMFASubmit = useLoginFlowSubmit(respondToAuthChallenge, getEmailMFAFormValues);

  return (
    <FormCard<Identity.API.UpdateMFATypeChallenge>
      headerLabel={
        <Text>
          For future logins, Blend will use the following email <Text weight="bold">{username}</Text> to send you a
          secure link to complete your login.
        </Text>
      }
      headerTitle="Email Verification"
      id={ID_SETUP_MFA_EMAIL}
      onSubmit={onEmailMFASubmit}
      showCancel={false}
      submitLabel="Complete activation"
    >
      <Text fontSize="sm" weight="medium">
        Want to use a mobile phone number instead?{' '}
        <LinkButton btnSize="sm" id="it-EmailMFA" inline label="Go back." onClick={() => setUseEmailMFA(false)} />
      </Text>
    </FormCard>
  );
};
